// Category names are stored/entered with a trailing "Category" word (e.g.
// "Attributes Category") that the redesigned display drops for a cleaner
// heading. Plain string comparison rather than a regex — a regex here would
// be a needless super-linear-backtracking surface for a one-line check.
export const stripCategorySuffix = (name: string): string => {
	const trimmed = name.trimEnd();
	const lower = trimmed.toLowerCase();
	const suffixStart = trimmed.length - 'category'.length;
	// Only strip a whole trailing word — "Subcategory" isn't "Sub", and a
	// name that's just "Category" has nothing else to fall back to.
	const isWholeWordSuffix =
		lower.endsWith('category') &&
		(suffixStart === 0 || /\s/.test(trimmed[suffixStart - 1]));
	if (isWholeWordSuffix) {
		const stripped = trimmed.slice(0, suffixStart).trimEnd();
		if (stripped !== '') return stripped;
	}
	return trimmed;
};
